<button mat-raised-button *ngIf="isButtonVisible && field.template.type === 'button'" [color]="field.template.color"
  [ngStyle]="field.buttonStyle" (click)="selectFile()">
  <mat-icon *ngIf="field.template.icon" [ngClass]="iconClass">
  </mat-icon>
  <span *ngIf="field.label" [innerHTML]="field.label | gioNoSanitize"></span>
</button>
<div class="text-title" *ngIf="field.template.type === 'text'">
  <label  [ngClass]="field.template.color" [ngClass]="{pointer: isButtonVisible}" [ngStyle]="field.buttonStyle"
    (click)="selectFile()">
    <i *ngIf="field.template.icon" [ngClass]="iconClass">
    </i>
    <span *ngIf="field.label" [innerHTML]="field.label | gioNoSanitize"></span>
  </label>
  <button *ngIf="isButtonVisible" mat-icon-button (click)="selectFile()">
    <mat-icon>add</mat-icon>
  </button>
</div>

<input #input_file style="display: none" type="file" accept="image/png, image/jpeg,application/pdf"
  (change)="fileSelected($event)" #fileInput>

<div class="list">
  <div class="label" *ngIf="files.length >0" [ngStyle]="field.labelStyle.container">
    <span [ngStyle]="field.labelStyle.span">
      Arquivos enviados
    </span>
  </div>
  <div class="files" *ngIf="files && files.length >0" [ngStyle]="field.filesStyle.container">
    <div class="file" *ngFor="let file of files" [ngStyle]="field.filesStyle.fileItem">
      <label [ngStyle]="field.filesStyle.label">{{file.file.name}} /
        {{fileHelper.humanFileSize(file.file.size)}}</label>
      <div class="actions">
        <mat-icon [ngStyle]="field.filesStyle.previewIcon" color="accent" class="pointer" (click)="preview(file)">
          visibility</mat-icon>
        <mat-icon [ngStyle]="field.filesStyle.clearIcon" color="warn" class="pointer" (click)="removeFile(file)">clear
        </mat-icon>

      </div>
    </div>
  </div>
</div>
